import { gql } from 'graphql-request';
import { ChartIds } from 'src/shared/types';

export const marineSedimentPollutionIndexMetricsQuery = gql`
    query marineSedimentPollutionIndexData($projectId: String!, $fromDate: String, $toDate: String, $habitatAssay: String!) {
        marineSedimentPollutionIndex: chart(
            projectId: $projectId
            chartId: "${ChartIds.MARINE_SEDIMENT_POLLUTION_INDEX}"
            habitatAssay: $habitatAssay
            fromDate: $fromDate
            toDate: $toDate
        ) {
            data
        }
    }
`;

export type MarineSedimentPollutionIndexData = {
    data: {
        data: {
            datetime: string;
            group: {
                type: string;
                value: number;
            }[];
        }[];
        metric: string;
    }[];
};

export type MarineSedimentPollutionIndexMetricsQueryResult = {
    marineSedimentPollutionIndex: MarineSedimentPollutionIndexData;
};
